export default __webpack_public_path__ + "static/media/Lightsaber Luke ROTJ - Img - Wip 5_18.5e918773.jpg";